
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'suspended': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path d="M6.5 0C2.91038 0 0 2.91038 0 6.5C0 10.0896 2.91038 13 6.5 13C10.0896 13 13 10.0896 13 6.5C13 2.91038 10.0896 0 6.5 0Z" fill="white"/><path fill- rule="evenodd" clip - rule="evenodd" d = "M3.70012 3.00059C3.87912 3.00059 4.05815 3.06882 4.19498 3.20565L6.4998 5.51054L8.80462 3.20565C8.87304 3.13724 8.95142 3.08539 9.03565 3.05118C9.28834 2.94855 9.5891 3.0004 9.79435 3.20565C10.068 3.47933 10.068 3.92174 9.79435 4.19541L7.48953 6.5003L9.79435 8.80518C9.9996 9.01044 10.0515 9.3112 9.94883 9.5639C9.91462 9.64814 9.86277 9.72652 9.79435 9.79494C9.72611 9.86318 9.64758 9.91384 9.56332 9.94805C9.47907 9.98226 9.38908 10 9.29949 10C9.12031 10 8.9411 9.93143 8.80462 9.79494L6.4998 7.49006L4.19498 9.79494C4.0585 9.93143 3.8793 10 3.70012 10C3.52094 10 3.34174 9.93143 3.20525 9.79494C2.93158 9.52126 2.93158 9.07886 3.20525 8.80518L5.51007 6.5003L3.20525 4.19541C2.93158 3.92174 2.93158 3.47933 3.20525 3.20565C3.34209 3.06882 3.52111 3.00059 3.70012 3.00059Z" fill="red" />'
  }
})
